import { setCloudStorageItem } from "@tradingApp/helpers/cloudStorage";
import type { TradingStorageState } from "../types";

export function tradingStorageStateSet(
  value: TradingStorageState,
): Promise<boolean> {
  return setCloudStorageItem("tradingState", JSON.stringify(value));
}
